import * as React from "react";
import { DataGrid, DataGridRow } from "~/components/DataGrid";
import { RowSizes } from "~/components/DataGrid/types";
import { ManagerColumns, ManagerWithAggregates } from "../..";
import { SortDirections } from "~/modules/filters/types";
import { useInMemoryManagerSort } from "./useInMemoryManagerSort";
import {
    RANK_COLUMN,
    NAME_COLUMN,
    RWA_ASSET_COUNT_COLUMN,
    DISTRIBUTED_RWA_TOTAL_VALUE_COLUMN,
    RWA_HOLDERS_COUNT_COLUMN,
    ASSET_CLASSES_COLUMN,
    DISTRIBUTION_PLATFORM_COLUMN,
    REPRESENTED_RWA_TOTAL_VALUE_COLUMN,
    NETWORKS_COLUMN,
} from "./columns";

// // // //

const TABLE_COLUMNS = [
    RANK_COLUMN,
    NAME_COLUMN,
    RWA_ASSET_COUNT_COLUMN,
    DISTRIBUTED_RWA_TOTAL_VALUE_COLUMN,
    REPRESENTED_RWA_TOTAL_VALUE_COLUMN,
    RWA_HOLDERS_COUNT_COLUMN,
    ASSET_CLASSES_COLUMN,
    DISTRIBUTION_PLATFORM_COLUMN,
    NETWORKS_COLUMN,
];

// // // //

/**
 * ManagerTable
 * Displays a table of managers with sorting capabilities
 */
export function ManagerTable(props: { rows: ManagerWithAggregates[] }) {
    const { rows } = props;
    const { query, setQuery, sortedItems } = useInMemoryManagerSort({
        rows,
        sort: {
            field: ManagerColumns.distributedValue,
            direction: SortDirections.desc,
        },
    });
    return (
        <DataGrid
            query={query}
            loading={false}
            columns={TABLE_COLUMNS}
            rows={sortedItems}
            rowKey="id"
            bordered
            fixedHeader
            size={RowSizes.small}
            paginationState={{
                page: 1,
                pageCount: 1,
                perPage: 100,
                resultCount: sortedItems.length,
            }}
            analyticsTableName="managers"
            onChangeQuery={setQuery}
        >
            {({ row, rowIndex, scrollLeft }) => (
                <DataGridRow
                    key={row.id}
                    row={{ ...row, rank: rowIndex + 1 }}
                    columns={TABLE_COLUMNS}
                    size={RowSizes.small}
                    striped={rowIndex % 2 === 1}
                    scrollLeft={scrollLeft}
                    bordered
                />
            )}
        </DataGrid>
    );
}
